import React from "react";
import { Box, Typography, Slider } from "@mui/material";
import { styled } from "@mui/material/styles";
import Rating from "@mui/material/Rating";
import {
  SentimentVeryDissatisfied as SentimentVeryDissatisfiedIcon,
  SentimentDissatisfied as SentimentDissatisfiedIcon,
  SentimentSatisfied as SentimentSatisfiedIcon,
  SentimentSatisfiedAltOutlined as SentimentSatisfiedAltIcon,
  SentimentVerySatisfied as SentimentVerySatisfiedIcon,
} from "@mui/icons-material";
import PropTypes from "prop-types";

// Constants (moved here as they are specific to this section)
const CUSTOM_ICONS = {
  1: {
    icon: <SentimentVeryDissatisfiedIcon color="error" />,
    label: "Very Dissatisfied",
  },
  2: {
    icon: <SentimentDissatisfiedIcon color="error" />,
    label: "Dissatisfied",
  },
  3: { icon: <SentimentSatisfiedIcon color="warning" />, label: "Neutral" },
  4: {
    icon: <SentimentSatisfiedAltIcon color="success" />,
    label: "Satisfied",
  },
  5: {
    icon: <SentimentVerySatisfiedIcon color="success" />,
    label: "Very Satisfied",
  },
};

const StyledRating = styled(Rating)(({ theme }) => ({
  "& .MuiRating-iconEmpty .MuiSvgIcon-root": {
    color: theme.palette.action.disabled,
  },
}));

const IconContainer = (props) => {
  const { value, ...other } = props;
  return <span {...other}>{CUSTOM_ICONS[value].icon}</span>;
};

IconContainer.propTypes = {
  value: PropTypes.number.isRequired,
};

const valuetext = (value) => `${value}m`;

const RatingsAndSlidersSection = ({
  depth,
  slogValue,
  surfaceSwimDistance,
  onChange,
}) => (
  <Box sx={{ width: "100%" }}>
    <Typography gutterBottom>
      Depth range (in meters): {depth[0]} to {depth[1]}
    </Typography>
    <Slider
      value={depth}
      onChange={(_, value) => onChange("depth", value)}
      valueLabelDisplay="auto"
      getAriaValueText={valuetext}
    />

    <Typography gutterBottom>Slog to water:</Typography>
    <StyledRating
      name="Slog-to-water"
      value={slogValue}
      onChange={(_, value) => onChange("slogValue", value)}
      size="small"
      IconContainerComponent={IconContainer}
      getLabelText={(value) => CUSTOM_ICONS[value].label}
      highlightSelectedOnly
    />

    <Typography gutterBottom>
      Surface swim distance (in meters): {surfaceSwimDistance}
    </Typography>
    <Slider
      value={surfaceSwimDistance}
      onChange={(_, value) => onChange("surfaceSwimDistance", value)}
      valueLabelDisplay="auto"
      getAriaValueText={valuetext}
      min={0}
      max={300}
    />
  </Box>
);

export default RatingsAndSlidersSection;
